module.exports = __webpack_public_path__ + "futurabt-bold-webfont-090c38cb0460768ee1837ef077eb558e.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/static/fonts/futurabt-bold-webfont.ttf
 ** module id = 1535
 ** module chunks = 0
 **/